// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"429":"1339954f","906":"99ebfdae"}[chunkId] + ".css";
};